module.exports = __webpack_public_path__ + "0ff9959dabaf6fe5fe77a7a38de3051f.svg";